import React from 'react';
import Splash from '../../Components/organisms/Splash/Splash';

const SplashScreen = () => {
  return (
    <div>
        <Splash />
    </div>
  )
}

export default SplashScreen